import { render } from "./RevenueUpdateSubAgent.vue?vue&type=template&id=618f379e"
import script from "./RevenueUpdateSubAgent.vue?vue&type=script&lang=js"
export * from "./RevenueUpdateSubAgent.vue?vue&type=script&lang=js"

import "./RevenueUpdateSubAgent.vue?vue&type=style&index=0&id=618f379e&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__